<h1 mat-dialog-title>{{ data.communication.communicationType }}</h1>
<div mat-dialog-content class="communication-content">
    <div class="communication-details">
        <p><strong>Sent To:</strong> {{ data.communication.name }}</p>
        <p *ngIf="data.communication.email"><strong>Email:</strong> <a href="mailto:{{ data.communication.email }}" target="_blank" rel="noopener">{{ data.communication.email }}</a></p>
        <p *ngIf="data.communication.mobileNumber"><strong>Mobile Number:</strong> <a href="tel:{{ data.communication.mobileNumber }}" target="_blank" rel="noopener">{{ data.communication.mobileNumber }}</a></p>
        <p *ngIf="data.communication.speciality"><strong>Speciality:</strong> {{ data.communication.speciality }}</p>
        <p *ngIf="data.communication.createdBy"><strong>Sent By:</strong> {{ data.communication.createdBy }}</p>
        <p *ngIf="data.communication.createdAt"><strong>Date:</strong> {{ data.communication.createdAt | date: 'medium' }}</p>
    </div>
    <div class="communication-text preserve-line-breaks" [innerHTML]="processedContent"></div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>

